module.exports = __webpack_public_path__ + "img/Character_Yae_Miko_Thumb.9eebe807.png";